import { ActionType } from '../../../core/redux/actionType';
import { ApiReducer, makeApiAction, makeApiReducer, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, addLoading, noLoadingNoError, getLoading } from '../../../core/api/module';
import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { UserInfo } from '../../authState';


const KEY_ACTION = ActionType.LoginRequest;
const ACTIONS = [
  ActionType.LoginRequest,
  ActionType.LoginResponse,
  ActionType.LoginError,
];


type Payload = UserInfo;


type Meta = {
  email: string;
  password: string;
};


/**
 * Dispatch this action to authenticate to the portal with user credentials
 * @param email - the email address associated with the account of the user attempting to authenticate
 * @param password - a secret string supplied by the user in support of their identity
 * @param checkSurveyPasskey - checks password against rater passkey
 */
export const loginAction = (
  email: string,
  password: string,
  checkSurveyPasskey: boolean) => makeApiAction<Payload, Meta>({
    method: 'POST',
    endpoint: Endpoints.Authenticate,
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ email: email, password: password, checkSurveyPasskey: checkSurveyPasskey }),
    types: makeRsaaTypes<Payload, Meta>(ACTIONS, { email: email, password: password }),
    bailout: state => !!getLoading(state, KEY_ACTION),
});

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  const updatedUser = payload;
  updatedUser!.passwordUsed = action.meta.password;

  return R.assocPath([ 'auth', 'currentUser' ], updatedUser, successState);
};

export const loginReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);